import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pagination } from '@shared/models/pagination.model';
import { BaseService } from '@shared/services/base.service';

import {
  StoreAvailableAdjustmentRequestListContent,
  StoreAvailableAdjustmentRequestSearchCriteria,
  StoreAvailableAdjustmentRequestViewResponse
} from '../model/store-available-adjustment-request.model';

@Injectable({
  providedIn: 'root'
})
export class StoreAvailableAdjustmentRequestService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.storeAvailableAdjustment;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getStoreAvailableAdjustmentRequestList(criteria: StoreAvailableAdjustmentRequestSearchCriteria) {
    const params = this.getParams(criteria);
    const url = this.getFullUrlWithStoreNo(this.envService.requestList);

    return this.http.get<Pagination<StoreAvailableAdjustmentRequestListContent>>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body',
      params
    });
  }

  getStoreAvailableAdjustmentRequestView(docNo: string) {
    const url = this.getFullUrlWithStoreNo(this.envService.requestView, { docNo });

    return this.http.get<StoreAvailableAdjustmentRequestViewResponse>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }
}
